import { createContext } from "react"
import { initialState } from "./reducer"
import { DashboardContextAction, DashboardContextState } from "./types"

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const DashboardContext = createContext<[DashboardContextState, React.Dispatch<DashboardContextAction>]>([initialState, () => {}])
